import React from 'react';
import {
    TouchableOpacity,
    View,
    ScrollView,
    Text,
    StyleSheet,
    // Modal,
    ToastAndroid,
    ImageBackground,
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import Config from '../../constants/Config';
import { GetProductInCart, GetProductMeta, GetProductStockCount } from '../../constants/Utils';
import { CartContext } from '../../contexts/cart/Store';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import Colors from '../../constants/Colors'
import FontStyles from '../../constants/FontStyle';
import CartIconStack from '../cart/CartIconStack';
import CartCountButton from '../cart/CartCountButton';
import StyledButton from '../StyledButton';
import StyledIcon from '../StyledIcon';
import OrderService from '../../services/OrderService';
import { IOrderGroupItem } from '../../interfaces/order';
import { IProduct } from '../../interfaces/product';
import { formatCurrency } from '../../utils/money';

interface IProps {
    product: IProduct,
    modalState: boolean,
    hideModal: any,
    navigateAway?: boolean
}

const analytics = new AnalyticsService();
const orderService = new OrderService('order_group');

const AddEditCartItemModal: React.FC<IProps> = ({ product, modalState, hideModal, navigateAway }) => {
    const navigation = useNavigation()
    const auth: any = React.useContext(AuthContext);
    const buyerData = auth.getUserData.buyerData;

    const [cart_state, cart_dispatch, cart_fetch] = React.useContext(CartContext)

    const clickAreaRef = React.useRef(null)

    const [submitted, setSubmitted] = React.useState(false)
    const [loadingContent, setLoadingContent] = React.useState(false)
    const [productItem, setProductItem]: [IProduct, any] = React.useState(product)
    const [orderQty, setOrderQty] = React.useState(10)
    const [unitPrice, setUnitPrice] = React.useState(0)
    const [price, setPrice] = React.useState(0)
    const [inCart, setInCart] = React.useState(false)
    const [stockCount, setStockCount] = React.useState(null)
    const [meta, setMeta] = React.useState(null)

    const gotoCart = () => {
        analytics.logEvent('Clicked Review Cart [Modal]', buyerData)
        hideModal()
        navigation.navigate('Cart')
    }

    const buyMore = () => {
        analytics.logEvent('Clicked Buy More [Modal]', buyerData)
        hideModal()
        if (navigateAway) {
            navigation.navigate('HomeTab', {
                screen: 'Manufacturer'
            })
        }
    }

    const gotoOrders = () => {
        hideModal()
        navigation.navigate('Orders')
    }


    const upsertCart = (group_id: string) => {

        setLoadingContent(true)

        if (!group_id) {
            setLoadingContent(false)
            // ToastAndroid.show('Something went wrong. Please try again.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            hideModal()
            return
        }

        let _orderGroupItem: IOrderGroupItem = {
            order_group_id: group_id,
            product_id: productItem._id,
            amount: price,
            quantity: orderQty
        }

        orderService
            .upsertItem(_orderGroupItem)
            .then(data => {
                let new_order_group_item = {
                    _id: inCart ? inCart?._id : data,
                    quantity: orderQty,
                    amount: price,
                    product_id: productItem._id,
                    order_group_id: group_id,
                    product: productItem
                }

                orderService
                    .fetchById(group_id, false)
                    .then((order_group_response: any) => {
                        cart_dispatch({ type: 'UPSERT_ORDER_GROUP_ITEM', payload: new_order_group_item })
                        cart_dispatch({ type: 'SET_ORDER_GROUP', payload: order_group_response })
                        analytics.logEvent('Added To Cart', buyerData, {
                            product_id: productItem._id,
                            product_name: productItem.name,
                            amount: price,
                            quantity: orderQty
                        })
                        setSubmitted(true)
                    })
                    .catch(err => {

                        cart_dispatch({ type: 'UPSERT_ORDER_GROUP_ITEM', payload: new_order_group_item })
                        setLoadingContent(false)
                        // ToastAndroid.show(err?.message || 'Could not refresh cart.', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
                        hideModal()
                    })

            })
            .catch(err => {
                console.log(err)
                setLoadingContent(false)
                // ToastAndroid.show('Product already added.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                hideModal()
            })

    }

    const proceedToCart = async () => {
        setLoadingContent(true)
        if (cart_state.order_group && cart_state.order_group._id) {
            upsertCart(cart_state.order_group._id)
        } else {
            await cart_fetch().then((group: any) => {
                // proceedToCart()
                upsertCart(group.length && group[0].order_group_id)
            }).catch((e: any) => {
                setLoadingContent(false)
                console.log(e)
                // ToastAndroid.show('Something went wrong. Please try again.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            })
        }
    }

    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                if (!loadingContent) {
                    hideModal()
                }
            }
        }
    }

    const ExitButton = () => {
        return <TouchableOpacity
            style={styles.exitButton}
            onPress={() => {
                hideModal()
            }} >
            <Icon name='md-close' size={24} color='#000000A0' />
        </TouchableOpacity>
    }

    React.useEffect(() => {
        setPrice(unitPrice * orderQty)
        return () => {
        }
    }, [orderQty])

    React.useEffect(() => {
        if (productItem) {

            setStockCount(GetProductStockCount(productItem))
            setMeta(GetProductMeta(productItem))
            let _inCart = GetProductInCart(cart_state, productItem?._id)
            if (_inCart) {
                setInCart(_inCart)
                setOrderQty(_inCart.quantity)
            } else {
                setOrderQty(productItem?.pricetag.mpu)
            }

            setUnitPrice(productItem?.pricetag.price / productItem.case_count)
            setPrice(productItem?.pricetag.price / productItem.case_count * orderQty)

            if (orderQty <= productItem?.pricetag.mpu) {
                // setMinState(true)
            }
        }

        return () => {
        }
    }, [productItem])

    React.useEffect(() => {
        setSubmitted(false)
        if (product) {
            setProductItem({ ...product })
        }
        return () => { }
    }, [])

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}
        >
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={[styles.overlay, { justifyContent: 'flex-end' }]}
            >
                <View style={[styles.container, { justifyContent: 'flex-end' }]}>

                    {
                        submitted
                            ? <>
                                <View style={[styles.card, styles.successCard, { marginBottom: 16 }]}>
                                    <ExitButton />
                                    {/* <Image source={require('../../assets/images/main/shopping-basket.png')} style={{ width: 53.37, height: 45.74, marginVertical: 12 }} /> */}
                                    <StyledIcon
                                        iconName="ios-checkmark-circle-outline"
                                        iconColor={Colors.greenColor}
                                        // outlineColor={Colors.greenColor}
                                        iconOnly
                                        size={50}
                                    />
                                    <Text style={[
                                        styles.cardBody,
                                        FontStyles.size14,
                                        FontStyles.lh22,
                                        FontStyles.normal,
                                        FontStyles.dark,
                                        {
                                            // width: 268,
                                            letterSpacing: 0,
                                            textAlign: 'center',
                                            marginTop: 12
                                        }]}>Product successfully added to cart.</Text>

                                    <View style={{ width: '100%', marginVertical: 16 }}>
                                        <CartIconStack borderColor={'#856404'} bgColor={'#FFF3CD'} />
                                    </View>
                                    
                                    <StyledButton
                                        label="Review Cart & Checkout"
                                        action={gotoCart}
                                        style={{
                                            marginTop: 10,
                                            height: 42,
                                        }}
                                    />
                                    <StyledButton
                                        label="Buy More Products"
                                        color="light"
                                        action={buyMore}
                                        style={{
                                            marginTop: 10,
                                            height: 42,
                                        }}
                                    />

                                </View>
                            </>
                            : productItem
                                ? <ScrollView
                                    contentContainerStyle={[styles.scrollWrapper]}
                                >
                                    <View style={styles.scrollCard}>
                                    <ExitButton />

                                        <View style={[styles.imageWrapper, { paddingVertical: productItem.pricetag.mpu === productItem.case_count && productItem.pricetag.mpu === 1 ? undefined : 9 }]}>
                                            {productItem.upload && <ImageBackground
                                                source={{ uri: `${Config.uploadUrl}${productItem.upload.path}` }}
                                                style={[styles.image]}
                                                resizeMode="contain">
                                            </ImageBackground>}
                                        </View>

                                        <Text style={[styles.cardBody, styles.cardHeader]}>{productItem.name}</Text>
                                        <Text style={[styles.cardBody, styles.cardSubHeader]}>{productItem.case_count} {productItem.pricetag.mpu === productItem.case_count && productItem.pricetag.mpu === 1 ? productItem?.tags?.HIGHER_UNIT?.value : productItem?.tags?.LOWER_UNIT?.value + 's / ' + productItem?.tags?.HIGHER_UNIT?.value}</Text>

                                        {
                                            !stockCount
                                                ? <Text style={[styles.cardBody, styles.cardOutOfStockText]}>Out of Stock {JSON.stringify(stockCount)}</Text>
                                                : <>
                                                    <Text style={[styles.cardBody, styles.cardPriceHeader]}>{formatCurrency(productItem.case_count * unitPrice)} for 1 {productItem?.tags?.HIGHER_UNIT?.value}</Text>
                                                    {
                                                        meta
                                                            ? meta.discount
                                                                ? <View style={[styles.cardBody, styles.productDiscountContainer]}>
                                                                    <Text style={styles.productDiscountPrice}>{formatCurrency(meta.discount)}</Text>
                                                                    <View style={styles.productDiscountBadge}>
                                                                        <StyledIcon
                                                                            iconName="ios-flash"
                                                                            iconColor={Colors.successText}
                                                                            iconOnly
                                                                            size={12}
                                                                        />
                                                                        <Text style={styles.productDiscountBadgeText}>Save {100 - Math.ceil((meta.discount / product.pricetag.price) * 100)}%</Text>
                                                                    </View>
                                                                </View>
                                                                : meta.market_price
                                                                    ? <Text style={[styles.cardBody, styles.cardDiscountHeader]}>
                                                                        <Text style={{ textDecorationLine: 'line-through' }}>{formatCurrency(meta.market_price)}</Text> (Market Price)</Text>
                                                                    : null
                                                            : null
                                                    }
                                                </>
                                        }

                                        <View style={styles.divider}></View>

                                        <CartCountButton
                                            product={productItem}
                                            stockCount={stockCount}
                                            orderQty={orderQty}
                                            setOrderQty={setOrderQty}
                                        />

                                        <View style={styles.divider}></View>


                                        <View style={[styles.cardBody, styles.selectionContainer]}>
                                            <Text style={styles.selectionHeader}>You Pay (<Text style={{ textTransform: 'uppercase' }}>{Config?.currencySymbol}</Text>)</Text>
                                            {
                                                stockCount
                                                    ? <Text style={styles.priceText}>{formatCurrency(price)}</Text>
                                                    : <Text style={styles.priceText}>{formatCurrency(0)}</Text>
                                            }
                                        </View>

                                        <View style={[styles.cardBody]}>
                                            <StyledButton
                                                size="lg"
                                                label={
                                                    stockCount
                                                        ? inCart
                                                            ? "Update Product"
                                                            : "Add Product"
                                                        : "Out of Stock"
                                                }
                                                action={proceedToCart}
                                                // action={() => setLoadingContent(!loadingContent)}
                                                style={{
                                                    height: 46,
                                                    marginTop: 10
                                                }}
                                                submitting={loadingContent}
                                                disabled={loadingContent || !stockCount}
                                            />
                                        </View>

                                    </View>

                                </ScrollView>
                                : null
                    }
                </View>
            </View>
        </Modal >
    )
}

export default AddEditCartItemModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        flex: 1,
        alignItems: 'center'
    },
    imageWrapper: {
        width: '100%',
        backgroundColor: Colors.whiteColor,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    image: {
        width: '100%',
        height: 170,
    },
    container: {
        flex: 1,
        width: '100%',
    },
    exitButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 2,
        width: 40,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20,
        backgroundColor: 'rgba(250,250,250,0.4)'
    },
    exitButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 20,
        paddingBottom: 16,
    },
    scrollWrapper: {
        flexGrow: 1,
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    scrollCard: {
        backgroundColor: Colors.whiteColor,
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        overflow: 'hidden',
        paddingBottom: 34,
    },
    successCard: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        backgroundColor: '#FFFFFF',
        marginHorizontal: 16,
        alignItems: 'center',
        paddingTop: 24
    },
    cardHeader: {
        ...FontStyles.normal,
        ...FontStyles.dark,
        ...FontStyles.size18,
        ...FontStyles.lh26,
        marginTop: 20,
    },
    cardSubHeader: {
        ...FontStyles.normal,
        ...FontStyles.gray,
        ...FontStyles.size14,
        ...FontStyles.lh18,
        marginTop: 6,
    },
    cardPriceHeader: {
        ...FontStyles.semibold,
        ...FontStyles.dark,
        ...FontStyles.size16,
        ...FontStyles.lh20,
        marginTop: 17,
    },
    cardOutOfStockText: {
        ...FontStyles.semibold,
        ...FontStyles.gray,
        ...FontStyles.size16,
        ...FontStyles.lh20,
        marginTop: 17,
    },
    cardDiscountHeader: {
        ...FontStyles.normal,
        ...FontStyles.size13,
        ...FontStyles.lh16,
        color: Colors.dangerText,
        marginTop: 5,
    },
    cardBody: {
        paddingHorizontal: 16,
        alignSelf: 'stretch'
    },
    divider: {
        alignSelf: 'stretch',
        height: 1,
        backgroundColor: Colors.shades._4,
        marginVertical: 12,
        marginHorizontal: 16,
    },
    selectionContainer: {
        alignSelf: 'stretch',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    selectionHeader: {
        ...FontStyles.normal,
        ...FontStyles.gray,
        ...FontStyles.size14,
        ...FontStyles.lh18,
        textTransform: 'capitalize'
    },
    counterWrapper: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 4,
        paddingHorizontal: 6,
        borderColor: '#3B54EC0D',
        backgroundColor: '#3B54EC1A',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 6,
    },
    counterBtn: {
        width: 34,
        height: 34,
        borderRadius: 17,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: Colors.tintColor,
        color: '#FFFFFF'
    },
    counterInput: {
        ...FontStyles.size14,
        ...FontStyles.lh22,
        ...FontStyles.semibold,
        ...FontStyles.dark,
        paddingVertical: 0,
        marginHorizontal: 20,
        textAlign: "center"
    },
    priceText: {
        ...FontStyles.size17,
        ...FontStyles.lh20,
        ...FontStyles.dark,
        ...FontStyles.bold,
        paddingVertical: 10,
    },
    productDiscountContainer: {
        flexDirection: 'row',
        marginTop: 5,
    },
    productDiscountPrice: {
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
        color: Colors.greyColor,
        textDecorationLine: 'line-through',
        alignSelf: 'center'
    },
    productDiscountBadge: {
        flexDirection: 'row',
        alignSelf: 'center',
        backgroundColor: Colors.successBackground,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 4,
        marginLeft: 4
    },
    productDiscountBadgeText: {
        ...FontStyles.size12,
        ...FontStyles.lh15,
        ...FontStyles.semibold,
        color: Colors.successText,
        marginLeft: 3,
    },
})
